module.exports = "<div class=\"wrapper\"> <div id=\"container\" class=\"container\"></div> </div> ";